module.exports = __webpack_public_path__ + "static/media/Clytemnestra.0ed688ff.jpg";